import React, { useState } from 'react'
import SectionContainer from '../../../Homepage/SectionContainer'
import BreadCrumb from '../../../component/BreadCrumb/BreadCrumb'
import Dropdown from '../../../component/dropdown/Dropdown'
import nepal from "../../../assets/kangaroo/nepalflag.png"
import australiaFlag from "../../../assets/kangaroo/newzealandflag.png"
import newZealandFlag from "../../../assets/kangaroo/newzealandflag.png"
import ukFlag from "../../../assets/kangaroo/newzealandflag.png"
import usaFlag from "../../../assets/kangaroo/canadaflag.png"
import chinaFlag from "../../../assets/kangaroo/newzealandflag.png"
import { Col, Row } from 'reactstrap'
import Fullform from '../../../component/FullForm/Fullform'
import Smallbutton from '../../../component/button/Smallbutton'
import Map from '../../../Homepage/Map'
import SmallPage from '../../../Homepage/SmallPage'


const Getfreecounseling = () => {
  const [countryCode, setCountryCode] = useState(null)
  const [selectedItem, setSelectedItem] = useState(null)
  const [studyDestination, setStudyDestination] = useState(null)
  const [studyLevel, setStudyLevel] = useState(null)
  const [time, setTime] = useState(null)

  return (
    <SectionContainer>
      <BreadCrumb items={[
        { title: "HOME", link: "/" },
        { title: "BOOK FOR CONSULTATION" },

      ]} />
      <h1 className='font-level-4 lh-1'>START SMART WITH A <br /> ONE-TO-ONE CONSULTATION SESSION</h1>
      <p className='country-paragraph-text'>Fill in your details below, and our team will connect with you to understand your situation and guide you on your next step in Australia.</p>

      <Fullform fullName={true} email={true} phone={true} serviceId={true} appointment={true}
        isAppointment={true}
        slots={true} preferedBranchId={true} message={true} closingdesc="Our counselor will connect with you shorty" closingHeading="YOU'RE ONE STEP CLOSE TO STARTING SMART!" closeFormat="normal" formOrigin={6} />

      <hr className='line' />

      <Map />
      <hr className='line-style-testprep' />
      <SmallPage countryPage={true} />



    </SectionContainer>
  )
}

export default Getfreecounseling
